'use strict';

import {ngDepModel} from './ngdepmodel.js';

export class memberModel extends ngDepModel
{
	constructor(itemData, $filter, jsDataService){
		super(itemData, $filter, jsDataService);
		this.setupItemData(itemData);
	}
	
	getValue(name){
		switch(name){
			case 'member':
				if(typeof(this.email) !== 'undefined'){
					return this.name + ' ' + this.lastname + ', ' + this.email;
				}
				else{
					return this.member_email;
				}
			case 'sign_status':
				return this.getClassifValue(name, 'sign_status');
			case 'actions':
//				console.log(name)
				return this.getClassifValue(name, 'site_actions');
			
		}
		if(typeof(this[name]) !== 'undefined' && this[name] !== ''){
			return this[name];
		}
		return null;
	}
}
